import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'timeAgo',
	pure: false
})
export class TimeAgoPipe implements PipeTransform {

	transform(ts:number|string) : any {
		let timestamp = parseInt(ts +"");
		if (isNaN(timestamp)) {
			throw new Error("Invalid timestamp");
		}
		let dif = new Date().getTime()/1000 - timestamp;

		let periods : Period[] = [
			new Period(10, "Ahora", 10, 1),
			new Period(55, "Hace unos segundos", 60, 1),				//		(- 5)
			new Period(115, "Hace un minuto", 120, 1),					//		(- 5)
			new Period(290, "Hace unos minutos", 300, 1),				//		60 * 5					5 minutos
			new Period(1780, "Hace _ minutos", 1800, 60),				//		60 * 30						Media hora
			new Period(1980, "Hace media hora", 1980, 1),				//		60 * 33						33 minutos
			new Period(3600, "Hace _ minutos", 3600, 60),				//		60 * 60						Una Hora
			new Period(7020, "Hace una hora", 7200, 1),					//		60 * 60	* 2					Dos horas
			new Period(85800, "Hace _ horas", 86400, 3600),				//		60 * 60 * 24				Un día
			new Period(172800, "Hace un día", 172800, 1),				//		60 * 60 * 24 * 2			Dos días
			new Period(604800, "Hace _ días", 604800, 86400),			//		60 * 60 * 24 * 7			Una semana
			new Period(1209600, "Hace una semana", 1209600, 1),			//		60 * 60 * 24 * 7 * 2		Dos semanas
			new Period(2419200, "Hace _ semanas", 2419200, 604800),		//		60 * 60 * 24 * 7 * 4		Cuatro semanas
			new Period(4838400, "Hace un mes", 4838400, 1),				//		60 * 60 * 24 * 7 * 8		Ocho semanas
			new Period(31536000, "Hace _ meses", 31536000, 2419200),	//		60 * 60 * 24 * 365			Un año
			new Period(63072000, "Hace un año", 63072000, 1),			//		60 * 60 * 24 * 365 * 2		Dos años
			new Period(Number.MAX_SAFE_INTEGER, "Hace _ años", Number.MAX_SAFE_INTEGER, 31536000)		//		∞
		];

		/*
								60							120							   5m
		hace unos segundos		 |		 hace un minuto		 |		hace unos minutos		|		hace n minutos
		*/

		for (let f = 0; f < periods.length; f++) {
			if (dif < periods[f].threshold) {
				let number = Math.floor(dif / periods[f].divideBy);
				return periods[f].text.replace("_", number.toString());
			}
		}

	}

}

class Period {

	/**
	 * Le ajusto los valores un poco para atras para que, por ejemplo, 23 horas y 55 minutos de diferencia caiga en "Hace un día" en lugar de "Hace 23 horas" 
	 */
	threshold : number;
	text : string;

	/**
	 * Uso trueTimeValue para calcular el número que tengo que poner para la verdadera diferencia entre dif y el periodo que representa un Period
	 */
	trueTimeValue : number;

	/**
	 * Unidad temporal del periodo que representa, expresada en segundos, por la que se divide dif para obtener la cantidad de minutos, horas, días, semanas o meses
	 */
	divideBy : number;

	constructor(threshold:number, text:string, trueTimeValue:number, divideBy:number) {
		this.threshold = threshold;
		this.text = text;
		this.trueTimeValue = trueTimeValue;
		this.divideBy = divideBy;
	}
}